import { Pressable, TextStyle, View } from "react-native";
import React from "react";
import { Text } from "@ui-kitten/components";
import { Feather } from "@expo/vector-icons";
import { LIGHT_BLUE } from "constants/";

interface Props {
  label: string;
  text: string | number;
  textColor?: string;
  fontWeight?: TextStyle["fontWeight"];
  showInfo?: boolean;
  onInfoPress?: () => void;
}

const PriceText: React.FC<Props> = (props) => {
  const {
    label,
    text,
    textColor = "black",
    fontWeight,
    showInfo,
    onInfoPress,
  } = props;

  return (
    <View
      style={{
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          flex: 1,
          width: "100%",
        }}
      >
        <Text
          style={{
            color: textColor,
            flex: 0.7,
            textAlign: "right",
            fontWeight,
          }}
        >
          <Pressable onPress={onInfoPress}>
            {showInfo && (
              <Feather
                name="info"
                color={LIGHT_BLUE}
                size={14}
                style={{ marginRight: 2 }}
              />
            )}
          </Pressable>
          {label} :
        </Text>

        <Text
          style={{
            color: textColor,
            flex: 0.3,
            textAlign: "right",
            fontWeight,
          }}
        >
          {text}
        </Text>
      </View>
    </View>
  );
};

export default PriceText;
